import {useCallback, useMemo} from 'react';
import {useUserSessionContext} from '../../../ui/sharedContexts/UserSessionContext';
import {useDropsSubscriptionsContext} from '../context/SubscriptionsProvider';
import {useIsSubscribed} from './useIsSubscribed';

export const useDefaultEmailValue = () => {
  const {email: userEmail} = useUserSessionContext();
  const {ayUser, guest, modalData} = useDropsSubscriptionsContext();
  const isAllDropsSubscribed = useIsSubscribed();

  const findCustomEmailsEntry = useCallback(
    (customEmailValue: number | 'all') => {
      return Object.entries(ayUser?.customEmails || {}).find(entry =>
        entry[1].includes(customEmailValue),
      )?.[0];
    },
    [ayUser?.customEmails],
  );

  return useMemo(() => {
    if (userEmail && isAllDropsSubscribed) {
      return findCustomEmailsEntry('all') || userEmail;
    }

    return (
      findCustomEmailsEntry(Number(modalData.dropId)) ||
      userEmail ||
      guest?.email ||
      ''
    );
  }, [
    userEmail,
    guest?.email,
    modalData.dropId,
    isAllDropsSubscribed,
    findCustomEmailsEntry,
  ]);
};
